import axiosRetry from 'axios-retry';
const DEFAULT_RETRYABLE_METHODS = ['get'];
const RETRYABLE_NETWORK_CODES = new Set([
    'ECONNRESET',
    'ETIMEDOUT',
    'ECONNABORTED',
    'ENOTFOUND',
    'EAI_AGAIN',
    'ERR_NETWORK',
]);
const EXTRA_RETRYABLE_HTTP_STATUSES = new Set([408, 429]);
export function isRetryableMethod(method, methods = DEFAULT_RETRYABLE_METHODS) {
    return method !== undefined && methods.includes(method.toLowerCase());
}
export function isRetryableError(error, methods = DEFAULT_RETRYABLE_METHODS) {
    var _a, _b;
    if (!isRetryableMethod((_a = error.config) === null || _a === void 0 ? void 0 : _a.method, methods))
        return false;
    if (error.code && RETRYABLE_NETWORK_CODES.has(error.code))
        return true;
    const status = (_b = error.response) === null || _b === void 0 ? void 0 : _b.status;
    if (status === undefined)
        return false;
    return (status >= 500 && status <= 599) || EXTRA_RETRYABLE_HTTP_STATUSES.has(status);
}
function parseRetryAfter(error) {
    var _a, _b;
    const raw = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b['retry-after'];
    if (raw === undefined || raw === null || raw === '')
        return undefined;
    const seconds = Number(raw);
    if (Number.isFinite(seconds))
        return seconds * 1000;
    const ts = Date.parse(String(raw));
    if (Number.isFinite(ts))
        return Math.max(0, ts - Date.now());
    return undefined;
}
export function buildRetryConfig(opts = {}) {
    var _a;
    return {
        retries: (_a = opts.retries) !== null && _a !== void 0 ? _a : 2,
        retryCondition: (error) => isRetryableError(error, opts.methods),
        retryDelay: (retryCount, error) => {
            const retryAfter = parseRetryAfter(error);
            if (retryAfter !== undefined)
                return retryAfter;
            return axiosRetry.exponentialDelay(retryCount, error, 100);
        },
        shouldResetTimeout: false,
    };
}
